import { render, staticRenderFns } from "./Transfers.vue?vue&type=template&id=807f65c4&scoped=true"
import script from "./Transfers.vue?vue&type=script&lang=js"
export * from "./Transfers.vue?vue&type=script&lang=js"
import style0 from "./Transfers.vue?vue&type=style&index=0&id=807f65c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807f65c4",
  null
  
)

export default component.exports